import { css } from "../../../../styled-system/css";

export const styles = {
  privacyCardsMobile: () =>
    css({
      marginBottom: "baseUnit.mobile8",
      desktop: {
        display: "none",
      },
    }),
  privacyCards: () =>
    css({
      display: "none",
      desktop: {
        display: "grid",
      },
      gridTemplateColumns: "repeat(3, minmax(min-content, max-content))",
      gap: "baseUnit.mobile4",
      justifyContent: "center",
      marginBottom: "baseUnit.mobile8",
    }),
  privacyCardWrapper: () =>
    css({
      border: "2px solid",
      borderColor: "backgroundGrey",
      "&:nth-of-type(even)": {
        backgroundColor: "backgroundGrey",
      },
      _hover: {
        textDecoration: "none",
        borderColor: "darkBlue",
      },
    }),
  privacyCategoryLink: () =>
    css({
      textDecoration: "none",
      height: "100%",
      "& > div": {
        height: "100%",
      },
    }),
};
